export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

// Hand-written month names per language. These are rendered directly (with
// the `notranslate` class) so the Google Translate widget cannot alter them,
// e.g. turning "March" into the verb "يمشى" or "May" into the verb "يمكن".
export const monthsAr = [
  'يناير',
  'فبراير',
  'مارس',
  'أبريل',
  'مايو',
  'يونيو',
  'يوليو',
  'أغسطس',
  'سبتمبر',
  'أكتوبر',
  'نوفمبر',
  'ديسمبر'
];

export const monthsDe = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember'
];

export const monthsFr = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre'
];

export const monthsEs = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre'
];

const MONTHS_BY_LANG = {
  en: months,
  ar: monthsAr,
  de: monthsDe,
  fr: monthsFr,
  es: monthsEs
};

// True when we have a hand-written month table for this language, in which
// case month names must be rendered with `notranslate`.
export const hasLocalMonths = lang => lang in MONTHS_BY_LANG && lang !== 'en';

export const getMonthName = (index, lang = 'en') =>
  (MONTHS_BY_LANG[lang] || months)[index];
